"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easing = {
  // No easing, no acceleration
  linear: function linear(t) {
    return t;
  },
  // Accelerates fast, then slows quickly towards end.
  quadratic: function quadratic(t) {
    return t * (-(t * t) * t + 4 * t * t - 6 * t + 4);
  },
  // Overshoots over 1 and then returns to 1 towards end.
  cubic: function cubic(t) {
    return t * (4 * t * t - 9 * t + 6);
  },
  // Overshoots over 1 multiple times - wiggles around 1.
  elastic: function elastic(t) {
    return t * (33 * t * t * t * t - 106 * t * t * t + 126 * t * t - 67 * t + 15);
  },
  // Accelerating from zero velocity
  inQuad: function inQuad(t) {
    return t * t;
  },
  // Decelerating to zero velocity
  outQuad: function outQuad(t) {
    return t * (2 - t);
  },
  // Acceleration until halfway, then deceleration
  inOutQuad: function inOutQuad(t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  // Accelerating from zero velocity
  inCubic: function inCubic(t) {
    return t * t * t;
  },
  // Decelerating to zero velocity
  outCubic: function outCubic(t) {
    return --t * t * t + 1;
  },
  // Acceleration until halfway, then deceleration
  inOutCubic: function inOutCubic(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  // Accelerating from zero velocity
  inQuart: function inQuart(t) {
    return t * t * t * t;
  },
  // Decelerating to zero velocity
  outQuart: function outQuart(t) {
    return 1 - --t * t * t * t;
  },
  // Acceleration until halfway, then deceleration
  inOutQuart: function inOutQuart(t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  // Accelerating from zero velocity
  inQuint: function inQuint(t) {
    return t * t * t * t * t;
  },
  // Decelerating to zero velocity
  outQuint: function outQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  // Acceleration until halfway, then deceleration
  inOutQuint: function inOutQuint(t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  },
  // Accelerating from zero velocity
  inSine: function inSine(t) {
    return -Math.cos(t * (Math.PI / 2)) + 1;
  },
  // Decelerating to zero velocity
  outSine: function outSine(t) {
    return Math.sin(t * (Math.PI / 2));
  },
  // Accelerating until halfway, then decelerating
  inOutSine: function inOutSine(t) {
    return -(Math.cos(Math.PI * t) - 1) / 2;
  },
  // Exponential accelerating from zero velocity
  inExpo: function inExpo(t) {
    return Math.pow(2, 10 * (t - 1));
  },
  // Exponential decelerating to zero velocity
  outExpo: function outExpo(t) {
    return -Math.pow(2, -10 * t) + 1;
  },
  // Exponential accelerating until halfway, then decelerating
  inOutExpo: function inOutExpo(t) {
    t /= .5;
    if (t < 1) return Math.pow(2, 10 * (t - 1)) / 2;
    t--;
    return (-Math.pow(2, -10 * t) + 2) / 2;
  },
  // Circular accelerating from zero velocity
  inCirc: function inCirc(t) {
    return -Math.sqrt(1 - t * t) + 1;
  },
  // Circular decelerating to zero velocity Moves VERY fast at the beginning and
  // then quickly slows down in the middle. This tween can actually be used
  // in continuous transitions where target value changes all the time,
  // because of the very quick start, it hides the jitter between target value changes.
  outCirc: function outCirc(t) {
    return Math.sqrt(1 - (t = t - 1) * t);
  },
  // Circular acceleration until halfway, then deceleration
  inOutCirc: function inOutCirc(t) {
    t /= .5;
    if (t < 1) return -(Math.sqrt(1 - t * t) - 1) / 2;
    t -= 2;
    return (Math.sqrt(1 - t * t) + 1) / 2;
  }
};